// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/icons/diamond.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-background.keno-game-wrapper {
  background-color: var(--bodyBg);
}
.game-background.keno-game-wrapper label {
  font-weight: 400;
}
.game-background.keno-game-wrapper .row.game-row {
  border-bottom: 0;
  overflow: hidden;
}
@media screen and (min-width: 991.98px) {
  .game-background.keno-game-wrapper .row.game-row {
    height: calc(100vh - 66px);
  }
}
.game-background.keno-game-wrapper .row.game-row .game-sidebar-col {
  font-size: 0.875rem;
}
@media screen and (min-width: 992px) {
  .game-background.keno-game-wrapper .row.game-row .game-sidebar-col {
    max-width: 350px;
    border-right: 1px solid rgba(239, 239, 239, 0.25);
  }
  .game-background.keno-game-wrapper .row.game-row .game-sidebar-col .game-sidebar-section {
    min-height: 450px;
    overflow: auto;
    height: calc(100vh - 75px);
  }
}
@media screen and (min-width: 1240px) {
  .game-background.keno-game-wrapper .row.game-row .game-sidebar-col {
    max-width: 480px;
  }
}
.game-background.keno-game-wrapper .row.game-row .game-sidebar-col .btn-configure-auto {
  min-height: 37px;
  letter-spacing: 1px;
  background: transparent;
  border: 1px solid var(--white);
  color: var(--white-100);
  border-radius: 4px;
  margin-top: 8px;
}
@media screen and (min-width: 991.98px) {
  .game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-elements {
    max-width: calc(100vh - 10px);
    min-width: 375px;
    margin: auto;
    width: 100%;
  }
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container {
  gap: 8px;
  row-gap: 8px;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  margin-bottom: 1rem;
}
@media screen and (max-width: 767.98px) {
  .game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container {
    gap: 0.25rem;
    margin-bottom: 1rem;
  }
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position {
  z-index: 999;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position .keno-win-loss-popup {
  border-color: var(--kenoSelected) !important;
  color: var(--kenoSelected);
  text-align: center;
  min-width: 191px;
  background-color: var(--black);
  animation-name: opacity_animation;
  animation-duration: 300ms;
  animation-timing-function: cubic-bezier(0.87, -0.41, 0.19, 1.44);
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position .keno-win-loss-popup h1 {
  font-weight: 900;
  font-size: 3.5rem;
  line-height: 0.9;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position .keno-win-loss-popup h1::after {
  content: "";
  display: block;
  height: 2px;
  width: 45px;
  background-color: var(--kenoSelected);
  margin: auto;
  margin-top: 8px;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position .keno-win-loss-popup.keno-loss {
  border-color: var(--red-600) !important;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position .keno-win-loss-popup.keno-loss h1 {
  color: var(--red-600);
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position .keno-win-loss-popup.keno-loss h1::after {
  content: none;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-win-loss-popup-position .keno-win-loss-popup h3 {
  font-weight: 900;
  font-size: 1.875rem;
  line-height: 0.8;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-grid-item {
  font-size: clamp(1rem, 1.5vw, 5.25rem);
  font-weight: 600;
  aspect-ratio: 1/1;
  border: 1px solid #353A47;
  border-radius: 5px;
  background: var(--NumberBg);
  padding: 0.25rem 0.4rem;
  cursor: pointer;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-grid-item:hover {
  background: var(--primary-95);
  color: var(--white);
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-grid-item.keno-select-box {
  background: var(--PlinkoSidebarBg);
  color: var(--white);
  animation-name: opacity_animation;
  animation-duration: 300ms;
  animation-timing-function: cubic-bezier(0.87, -0.41, 0.19, 1.44);
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-grid-item.keno-failed-box {
  color: var(--danger);
  border-radius: 5px;
  border: 1px solid #353A47;
  background: #13151A;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-numbers-container .keno-grid-item.keno-success-box {
  align-items: center !important;
  justify-content: center !important;
  color: var(--black);
  position: relative;
  border-radius: 5px;
  border: 1px solid #1A9A8F;
  background-color: #0E0E0E;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 85%;
  background-repeat: no-repeat;
  background-position: center;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-multiply-container {
  min-height: 38px;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-multiply-container .keno-multiply-select-item {
  background: var(--primary-95);
  font-size: 1rem;
  font-weight: 500;
}
@media screen and (max-width: 767.98px) {
  .game-background.keno-game-wrapper .row.game-row .game-area-col .keno-multiply-container .keno-multiply-select-item {
    font-size: 75%;
    writing-mode: vertical-rl;
  }
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-content-container {
  background: var(--TabBgActive);
  min-height: 49px;
  border-radius: 5px;
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-content-container .keno-game-content-item {
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: var(--primary-95);
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-content-container .keno-game-content-item img {
  width: 17px;
}
@media screen and (max-width: 399.99px) {
  .game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-content-container .keno-game-content-item {
    flex-direction: column;
  }
}
@media screen and (max-width: 767.98px) {
  .game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-content-container .keno-game-content-item {
    font-size: 75%;
  }
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-content-container .keno-game-content-item:is(.active, :hover) {
  background: var(--TabBgActive);
  border: 1px solid var(--textColor);
}
.game-background.keno-game-wrapper .row.game-row .game-area-col .keno-game-content-container .keno-game-content-item svg {
  filter: drop-shadow(0px var(--Spacing-s-4, 4px) 5px rgba(255, 222, 82, 0.4));
}
.game-background.keno-game-wrapper .form-control {
  border: 1px solid var(--primary-95);
  background: var(--WagerInput) !important;
  color: var(--textColor);
  min-height: 40px !important;
  font-weight: 400;
  font-size: 14px;
}
.game-background.keno-game-wrapper .form-control.numberOfBets {
  border: none;
  background: var(--primary-95);
  color: var(--textColor);
  padding-left: 10px;
}
.game-background.keno-game-wrapper .form-control:focus, .game-background.keno-game-wrapper .form-control:focus-visible {
  outline: 0;
  box-shadow: none;
}
.game-background.keno-game-wrapper .form-control:disabled {
  opacity: 0.5;
}
.game-background.keno-game-wrapper .form-control:read-only {
  cursor: auto;
}

@keyframes opacity_animation {
  0% {
    opacity: 0;
    transform: scale(0);
  }
}
#mines-fairness-popup input.form-control {
  background-color: var(--buttonBg);
  border-color: var(--buttonBg);
  border-radius: 4px !important;
}
#mines-fairness-popup input:focus {
  color: var(--textColor);
}
#mines-fairness-popup .keno-numbers-container .keno-grid-item {
  max-width: 40px;
  font-size: 1rem;
}

.icon-keno-padding {
  padding: 0px 0px 0px 2.86px;
}

.keno-fairness-modal-result {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/games/Keno/GameTheme/KenoGame/kenoGame.scss"],"names":[],"mappings":"AACE;EACE,+BAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAIM;EACE,gBAAA;EACA,gBAAA;AAFR;AAIQ;EAJF;IAKI,0BAAA;EADR;AACF;AAIQ;EACE,mBAAA;AAFV;AAIU;EAHF;IAII,gBAAA;IACA,iDAAA;EADV;EAGU;IACE,iBAAA;IACA,cAAA;IACA,0BAAA;EADZ;AACF;AAIU;EAdF;IAeI,gBAAA;EADV;AACF;AAIU;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAFZ;AAiBY;EADF;IAEI,6BAAA;IACA,gBAAA;IACA,YAAA;IACA,WAAA;EAdZ;AACF;AAiBU;EACE,QAAA;EACA,YAAA;EAEA,gDAAA;EACA,mBAAA;AAhBZ;AAkBY;EAPF;IAQI,YAAA;IACA,mBAAA;EAfZ;AACF;AAkBY;EACE,YAAA;AAhBd;AAkBc;EACE,4CAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;EACA,yBAAA;EACA,gEAAA;AAhBhB;AAkBgB;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAhBlB;AAkBkB;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,YAAA;EACA,eAAA;AAhBpB;AAoBgB;EACE,uCAAA;AAlBlB;AAoBkB;EACE,qBAAA;AAlBpB;AAoBoB;EACE,aAAA;AAlBtB;AAuBgB;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AArBlB;AA0BY;EAEE,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;AAzBd;AA+Bc;EACE,6BAAA;EACA,mBAAA;AA7BhB;AAoCc;EACE,kCAAA;EACA,mBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gEAAA;AAlChB;AAqCc;EACE,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAnChB;AAsCc;EACE,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,oBAAA;EACA,4BAAA;EACA,2BAAA;AApChB;AAyCU;EACE,gBAAA;AAvCZ;AAyCY;EACE,6BAAA;EAEA,eAAA;EACA,gBAAA;AAxCd;AA0Cc;EANF;IAOI,cAAA;IACA,yBAAA;EAvCd;AACF;AA2CU;EACE,8BAAA;EACA,gBAAA;EAEA,kBAAA;AA1CZ;AA4CY;EACE,eAAA;EAEA,iBAAA;EACA,gBAAA;EACA,mCAAA;AA3Cd;AA6Cc;EACE,WAAA;AA3ChB;AA8Cc;EAXF;IAYI,sBAAA;EA3Cd;AACF;AA6Cc;EAfF;IAgBI,cAAA;EA1Cd;AACF;AA4Cc;EACE,8BAAA;EACA,kCAAA;AA1ChB;AA6Cc;EACE,4EAAA;AA3ChB;AAmDI;EACE,mCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AAjDN;AAqDM;EACE,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;AAnDR;AAsDM;EAEE,UAAA;EACA,gBAAA;AArDR;AAwDM;EACE,YAAA;AAtDR;AAyDM;EACE,YAAA;AAvDR;;AA6DA;EACE;IACE,UAAA;IACA,mBAAA;EA1DF;AACF;AA+DI;EACE,iCAAA;EACA,6BAAA;EACA,6BAAA;AA7DN;AAgEI;EACE,uBAAA;AA9DN;AAkEE;EACE,eAAA;EACA,eAAA;AAhEJ;;AAoEA;EACE,2BAAA;AAjEF;;AAmEA;EACE,oBAAA;AAhEF","sourcesContent":[".game-background {\n  &.keno-game-wrapper {\n    background-color: var(--bodyBg);\n\n    label {\n      font-weight: 400;\n    }\n\n    .row {\n      &.game-row {\n        border-bottom: 0;\n        overflow: hidden;\n\n        @media screen and (min-width:991.98px) {\n          height: calc(100vh - 66px);\n        }\n\n        // left bar style\n        .game-sidebar-col {\n          font-size: 0.875rem;\n\n          @media screen and (min-width: 992px) {\n            max-width: 350px;\n            border-right: 1px solid rgba(239, 239, 239, 0.25);\n\n            .game-sidebar-section {\n              min-height: 450px;\n              overflow: auto;\n              height: calc(100vh - 75px);\n            }\n          }\n\n          @media  screen and (min-width : 1240px) {\n            max-width: 480px;\n\n          }\n\n          .btn-configure-auto {\n            min-height: 37px;\n            letter-spacing: 1px;\n            background: transparent;\n            border: 1px solid var(--white);\n            color: var(--white-100);\n            border-radius: 4px;\n            margin-top: 8px;\n          }\n\n          // .btn-place-bet {\n          //   background: var(--PlaceBetBg);\n          //   border-color: transparent;\n          //   border-radius: 4px;\n          //   color: var(--PlaceBetColor);\n          // }\n        }\n\n        // right bar style\n        .game-area-col {\n\n          .keno-game-elements {\n            @media screen and (min-width: 991.98px) {\n              max-width: calc(100vh - 10px);\n              min-width: 375px;\n              margin: auto;\n              width: 100%;\n            }\n          }\n\n          .keno-numbers-container {\n            gap: 8px;\n            row-gap: 8px;\n            // max-width: 620px;\n            grid-template-columns: repeat(8, minmax(0, 1fr));\n            margin-bottom: 1rem;\n\n            @media screen and (max-width: 767.98px) {\n              gap: 0.25rem;\n              margin-bottom: 1rem;\n              // max-width: 300px;\n            }\n\n            .keno-win-loss-popup-position {\n              z-index: 999;\n\n              .keno-win-loss-popup {\n                border-color: var(--kenoSelected) !important;\n                color: var(--kenoSelected);\n                text-align: center;\n                min-width: 191px;\n                background-color: var(--black);\n                animation-name: opacity_animation;\n                animation-duration: 300ms;\n                animation-timing-function: cubic-bezier(.87, -.41, .19, 1.44);\n\n                h1 {\n                  font-weight: 900;\n                  font-size: 3.5rem;\n                  line-height: .9;\n\n                  &::after {\n                    content: '';\n                    display: block;\n                    height: 2px;\n                    width: 45px;\n                    background-color: var(--kenoSelected);\n                    margin: auto;\n                    margin-top: 8px;\n                  }\n                }\n\n                &.keno-loss {\n                  border-color: var(--red-600) !important;\n\n                  h1 {\n                    color: var(--red-600);\n\n                    &::after {\n                      content: none;\n                    }\n                  }\n                }\n\n                h3 {\n                  font-weight: 900;\n                  font-size: 1.875rem;\n                  line-height: .8;\n                }\n              }\n            }\n\n            .keno-grid-item {\n              // max-width: 70px;\n              font-size: clamp(1rem, 1.5vw, 5.25rem);\n              font-weight: 600;\n              aspect-ratio: 1/1;\n              border: 1px solid #353A47;\n              border-radius: 5px;\n              background: var(--NumberBg);\n              padding: 0.25rem 0.4rem;\n              cursor: pointer;\n\n              // @media screen and (max-width: 767.98px) {\n              //   max-width: 35px;\n              // }\n\n              &:hover {\n                background: var(--primary-95);\n                color: var(--white);\n              }\n\n              // @media screen and (max-width: 767.98px) {\n              //   font-size: 75%;\n              // }\n\n              &.keno-select-box {\n                background: var(--PlinkoSidebarBg);\n                color: var(--white);\n                animation-name: opacity_animation;\n                animation-duration: 300ms;\n                animation-timing-function: cubic-bezier(.87, -.41, .19, 1.44);\n              }\n\n              &.keno-failed-box {\n                color: var(--danger);\n                border-radius: 5px;\n                border: 1px solid #353A47;\n                background: #13151A;\n              }\n\n              &.keno-success-box {\n                align-items: center !important;\n                justify-content: center !important;\n                color: var(--black);\n                position: relative;\n                border-radius: 5px;\n                border: 1px solid #1A9A8F;\n                background-color: #0E0E0E;\n                background-image: url('../../../../assets/icons/diamond.png');\n                background-size: 85%;\n                background-repeat: no-repeat;\n                background-position: center;\n              }\n            }\n          }\n\n          .keno-multiply-container {\n            min-height: 38px;\n\n            .keno-multiply-select-item {\n              background: var(--primary-95);\n              // font-size: 0.625rem;\n              font-size: 1rem;\n              font-weight: 500;\n\n              @media screen and (max-width: 767.98px) {\n                font-size: 75%;\n                writing-mode: vertical-rl;\n              }\n            }\n          }\n\n          .keno-game-content-container {\n            background: var(--TabBgActive);\n            min-height: 49px;\n            // max-width: 620px;\n            border-radius: 5px;\n\n            .keno-game-content-item {\n              cursor: pointer;\n              // font-size: 0.875rem;\n              font-size: 1.2rem;\n              font-weight: 600;\n              background-color: var(--primary-95);\n\n              img {\n                width: 17px;\n              }\n\n              @media screen and (max-width: 399.99px) {\n                flex-direction: column;\n              }\n\n              @media screen and (max-width: 767.98px) {\n                font-size: 75%;\n              }\n\n              &:is(.active, :hover) {\n                background: var(--TabBgActive);\n                border: 1px solid var(--textColor);\n              }\n\n              svg {\n                filter: drop-shadow(0px var(--Spacing-s-4, 4px) 5px rgba(255, 222, 82, 0.40));\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .form-control {\n      border: 1px solid var(--primary-95);\n      background: var(--WagerInput) !important;\n      color: var(--textColor);\n      min-height: 40px !important;\n      font-weight: 400;\n      font-size: 14px;\n      // padding-left: 25px;\n      // padding-right: 70px;\n\n      &.numberOfBets {\n        border: none;\n        background: var(--primary-95);\n        color: var(--textColor);\n        padding-left: 10px;\n      }\n\n      &:focus,\n      &:focus-visible {\n        outline: 0;\n        box-shadow: none;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n      }\n\n      &:read-only {\n        cursor: auto;\n      }\n    }\n  }\n}\n\n@keyframes opacity_animation {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n}\n\n#mines-fairness-popup {\n  input {\n    &.form-control {\n      background-color: var(--buttonBg);\n      border-color: var(--buttonBg);\n      border-radius: 4px !important;\n    }\n\n    &:focus {\n      color: var(--textColor);\n    }\n  }\n\n  .keno-numbers-container .keno-grid-item {\n    max-width: 40px;\n    font-size: 1rem;\n  }\n}\n\n.icon-keno-padding {\n  padding: 0px 0px 0px 2.86px;\n}\n.keno-fairness-modal-result{\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
